import { z } from 'zod';
import { keepSessionResponseSchema, releaseSessionResponseSchema, sessionSummarySchema, sessionTimelineEventDetailSchema, sessionTimelineQuerySchema, sessionTimelineResponseSchema, } from '../contracts/agent-sessions';
import { organizationIdSchema, } from '../contracts/organizations';
import { parseSchema } from '../errors';
/**
 * Typed client helpers for the agent session timeline (KIR-4445). Every call is
 * addressed by an alert occurrence (`findings.id`), never by a session id: the
 * server authorizes through the occurrence and derives the session from it.
 *
 * `organizationId` null → the personal-account routes.
 */
const occurrenceIdSchema = z.uuid();
const eventIdSchema = z.string().min(1).max(128);
function sessionBasePath(organizationId, occurrenceId) {
    const validatedOccurrence = parseSchema(occurrenceIdSchema, occurrenceId);
    if (organizationId === null) {
        return `/account/alert-occurrences/${validatedOccurrence}/session`;
    }
    const validatedOrg = parseSchema(organizationIdSchema, organizationId);
    return `/organizations/${validatedOrg}/alert-occurrences/${validatedOccurrence}/session`;
}
export async function getAlertSessionTimeline(client, organizationId, occurrenceId, query = {}) {
    const params = parseSchema(sessionTimelineQuerySchema, query);
    const response = await client.get(`${sessionBasePath(organizationId, occurrenceId)}/timeline`, { params });
    return parseSchema(sessionTimelineResponseSchema, response);
}
export async function getAlertSessionSummary(client, organizationId, occurrenceId) {
    const response = await client.get(`${sessionBasePath(organizationId, occurrenceId)}/summary`);
    return parseSchema(sessionSummarySchema, response);
}
export async function getAlertSessionEvent(client, organizationId, occurrenceId, eventId) {
    const validatedEvent = parseSchema(eventIdSchema, eventId);
    const response = await client.get(`${sessionBasePath(organizationId, occurrenceId)}/events/${encodeURIComponent(validatedEvent)}`);
    return parseSchema(sessionTimelineEventDetailSchema, response);
}
export async function keepAlertSession(client, organizationId, occurrenceId) {
    const response = await client.post(`${sessionBasePath(organizationId, occurrenceId)}/keep`);
    return parseSchema(keepSessionResponseSchema, response);
}
export async function releaseAlertSession(client, organizationId, occurrenceId) {
    const response = await client.delete(`${sessionBasePath(organizationId, occurrenceId)}/keep`);
    return parseSchema(releaseSessionResponseSchema, response);
}
//# sourceMappingURL=agent-sessions.js.map